module.exports = __webpack_public_path__ + "static/assets/0f8250c86da66d5e91b16c369c3cd92b.svg";